var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fo-layout-tpl"},[_c('div',{staticClass:"fo-layout-mode",class:{'fo-layout-mode-wid': _vm.noWhite}},[_c('div',{staticClass:"title-bar"},[_c('p',{staticClass:"primary title-alt"},[_vm._t("alt")],2),_vm._v(" "),_c('h1',{staticClass:"primary title"},[_vm._t("title")],2)]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b97d84de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compos/layoutMode.vue
// module id = null
// module chunks = 